<template lang="html">

  <div class="question-block">
    <div class="dragging__dots">
      <span class="dragging__dot"></span>
      <span class="dragging__dot"></span>
      <span class="dragging__dot"></span>
    </div>
    <div class="voice-bot__question-containerZZ row-block">
      <div class="col-sm-11 block-title">
        <div class="number">
          {{ index + 1 }}.
        </div>
        <div style="width: 100%;">
          <textarea
              type="text"
              class="form-control vcv-input question-text"
              v-model="body"
              style="width: 100%;"
          ></textarea>
        </div>
      </div>
      <div class="col-sm-1 text-center">
        <button
            class="vcv-button garbage-gray"
            @click="deleteQuestion(model)"
            v-tooltip.top-center="$tr('common.iconTooltips.deleteSelectedQuestions')">
        >
          <i class="icon icon-garbage icon-garbage_gray"></i>
        </button>
      </div>

    </div>
    <div class="voice-bot__play-container">
        <div v-if="!model.playing" class="play-container">
            <div
                @click="playAudio(model)"
                class="play-container__play"
            ></div>
            {{ $tr('vacancy.voiceBot.playQuestions') }}
        </div>
        <div v-else class="play-container">
            <div
                @click="stopAudio(model)"
                class="play-container__stop"
            ></div>
            {{ $tr('vacancy.voiceBot.stopQuestions') }}
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vacancy-voicebot-question-row',

  components: {},

  data () {
    return {
      progressUpdater: {},
      progress: 0
    }
  },

  props: {
    model: Object,
    index: Number
  },

  methods: {
    playAudio () {
      this.$store.dispatch('vacancy/voicebot/playAudio', this.model, () => {
        this.$store.dispatch('vacancy/voicebot/stopAudio', this.model)
      })
    },

    stopAudio () {
      this.$store.dispatch('vacancy/voicebot/stopAudio', this.model)
    },

    updateQuestion () {
      this.$store.dispatch('vacancy/voicebot/updateQuestions', { questions: [this.model] })
    },

    deleteQuestion (question) {
      this.$store.commit('vacancy/voicebot/deleteQuestion', { model: question })
    },

    updateModel (data) {
      this.$store.commit('vacancy/voicebot/updateQuestion', {
        model: this.model,
        data: data
      })
    }
  },

  computed: {
    body: {
      get () {
        return this.model.body
      },

      set (val) {
        this.updateModel({
          body: val
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .question-block {
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 14px;
    padding: 5px 11px 19px 13px;
  }

  .question-block:last-child {
    margin-bottom: 0;
  }

  .dragging__dots {
    position: relative;
    width: 100px;
    margin: 0 auto;
    cursor: move;
    text-align: center;
  }

  .dragging__dots .dragging__dot {
    width: 5px;
    height: 5px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 10px 2px;
    display: inline-block;
  }

  .question-block .row-block .block-title {
    display: flex;
  }

  .voice-bot__question-container .block-title {
    display: flex;
    margin-bottom: 10px;
  }

  .play-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .play-container__play,
  .play-container__stop {
    display: inline-block;
    cursor: pointer;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .play-container__stop {
    background: url(/static/images/elements/pause-btn.png) no-repeat center;
  }

  .play-container__play {
    background: url(/static/images/elements/play-btn.png) no-repeat center;
  }

  .question-text {
    resize: vertical;
    border-color: lightgray;
    margin-left: 10px;
  }

  .question-text:not(:focus) {
    border: none;
    box-shadow: none;
    resize: none;
  }

  .number {
    width: 30px;
    font-size: 24px;
    font-weight: bold;
    padding-left: 5px;
    color: $green;
  }

  .garbage-gray:hover {
    border-color: red;
  }

  .icon-garbage_gray:hover {
    color: red;
  }

  .vcv-button .icon {
    width: 34px;
  }
</style>
